import { Grid } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const DateRangePicker = ({
  startDate = new Date(),
  setStartDate,
  endDate = new Date(),
  setEndDate,
}) => {
  const start = dayjs(startDate).toDate();
  const end = dayjs(endDate).toDate();
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ fontSize: "1rem", lineHeight: "1rem", padding: "0 .5rem" }}>Start Date :</span>
      <div>
        <DatePicker
          selected={start}
          onChange={(date) => setStartDate(dayjs(date).format("YYYY-MM-DD"))}
          selectsStart
          startDate={start}
          endDate={end}
          dateFormat="dd / MM / yyyy"
        />
      </div>

      <span style={{ fontSize: "1rem", lineHeight: "1rem", padding: "0 .5rem" }}>End Date :</span>

      <DatePicker
        selected={end}
        onChange={(date) => setEndDate(dayjs(date).format("YYYY-MM-DD"))}
        selectsEnd
        startDate={start}
        endDate={end}
        minDate={start}
        dateFormat="dd / MM / yyyy"
      />
    </div>
  );
};

export const LoadManifestDatePicker2 = ({ setStartDate }) => {
  const [selected, setSelected] = useState(null);
  return (
    <DatePicker
      showIcon
      selected={selected}
      onChange={(date) => {
        let value;
        if (date === null) {
          value = date;
        } else {
          value = dayjs(date).format("YYYY-MM-DD HH:mm");
        }
        setStartDate(value);
        setSelected(date)
      }}
      timeInputLabel="Time:"
      showTimeInput
      dateFormat="dd/MM/yyyy h:mm aa"
    />
  );
};
